import { setTokens } from './setTokens.interceptor';

export const interceptors = {
  setTokens,
};
